// @flow

/**
 * Shared layout styles for components that need to work with MemberDrawer
 * These styles ensure content is properly positioned relative to the fixed drawer
 */

const sharedLayoutStyles = {
  // Root container for *Home components
  homeRoot: (theme) => ({
    minHeight: '100vh',
    display: 'flex'
  }),

  // Content area that accounts for drawer offset
  mainContent: (theme) => ({
    flexGrow: 1,
    marginTop: `${theme.layout.customProps.header.height * 2}px`, // Account for header height
    marginLeft: 0, // Let the drawer handle its own positioning
    width: '100%',
    minHeight: `calc(100vh - ${theme.layout.customProps.header.height * 2}px)`,
    [theme.breakpoints.up('sm')]: {
      // On desktop, account for the drawer width
      marginLeft: `${theme.layout.customProps.drawer.width}px`,
      width: `calc(100% - ${theme.layout.customProps.drawer.width}px)`
    }
  }),

  // Toolbar spacer that matches the header height
  toolbar: (theme) => ({
    ...theme.mixins.toolbar,
    minHeight: `${theme.layout.customProps.header.height * 2}px !important`
  }),

  // Content wrapper with proper spacing
  contentWrapper: (theme) => ({
    padding: theme.spacing(3),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5)  // 12px padding on mobile
    }
  })
};

export default sharedLayoutStyles;
